import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,[_c(VTabs,[_c(VTab,{key:"general",attrs:{"to":"/profile/general"}},[_vm._v("General")]),_c(VTab,{key:"account",attrs:{"to":"/profile/account"}},[_vm._v("Account")])],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }